<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="affect-client-cards-dialog"
      :open.sync="openDialog"
      :form-ref.sync="affectClientCardFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Affecter un lot de cartes</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <affect-client-card-form
            :form.sync="affectClientCardForm"
            :rules="rules"
          ></affect-client-card-form>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.save`]>
        <span>Affecter</span>
      </template>
    </base-dialog>
  </div>
</template>
<script>
import { defineComponent, computed, toRefs } from "@vue/composition-api";
import BaseDialog from "../General/BaseDialog.vue";
import AffectClientCardForm from "./AffectClientCardForm.vue";
import { useCardEdition } from "@/composables/cards-edition";

export default defineComponent({
  components: {
    BaseDialog,
    AffectClientCardForm,
  },
  props: {
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const {
      editionData,
      affectClientCardEdition,
      listCardEditions,
    } = useCardEdition();

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const saveItem = async function () {
      if (
        !editionData.affectClientCardForm.changeSessionsNumber &&
        editionData.affectClientCardForm.sessionsNumber
      ) {
        delete editionData.affectClientCardForm.sessionsNumber;
      }
      delete editionData.affectClientCardForm.changeSessionsNumber;
      await affectClientCardEdition(editionData.affectClientCardForm);
      openDialog.value = false;
      listCardEditions();
    };

    return {
      openDialog,
      saveItem,
      ...toRefs(editionData),
    };
  },
});
</script>
